var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<label class=\"empty-text-message col-sm-12  fst-italic control-label text-center\"><small>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"emptyText") || (depth0 != null ? lookupProperty(depth0,"emptyText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"emptyText","hash":{},"data":data,"loc":{"start":{"line":20,"column":89},"end":{"line":20,"column":102}}}) : helper)))
    + "</small></label>";
},"useData":true});